// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";



export const FirestoreDB = window.G_firebase_auth.IV_firestore_object;
